<template>
    <form class="reminder-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['texto_boton']}">
            <label for="texto_boton" class="col-sm-4 control-label">Texto botón</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="texto_boton" v-model="data.texto_boton" :maxlength="200">
                 
                <div class="help-block" v-for="(e,index) in errors['texto_boton']" :key="index">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['url_destino']}">
            <label for="url_destino" class="col-sm-4 control-label">Url de destino</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="url_destino" v-model="data.url_destino">
                <div class="help-block" v-for="(e,index) in errors['url_destino']" :key="index">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['activar_texto_modal']}">
            <label for="activar_texto_modal" class="col-sm-4 control-label">Texto Libre </label>
            <div class="col-sm-8  ">
                <el-switch
                    v-model="data.activar_texto_modal"
                    on-text="SI"
                    off-text="NO"                    
                    >
                </el-switch>
            </div>
        </div>
        <div class="form-group" v-if="data.activar_texto_modal" :class="{'has-error': errors['texto_modal']}">
            <label for="texto_institucion" class="col-sm-4 control-label">Texto Modal</label>
            <div class="col-sm-8">
                <textarea class="form-control" id="texto_modal" v-model="data.texto_modal" rows="3"></textarea>
                <div class="help-block" v-for="(e,index) in errors['texto_modal']" :key="index">{{e}}</div>
            </div>
        </div>
        <div class="form-group" v-if="!data.activar_texto_modal" :class="{'has-error': errors['texto_valor']}">
            <label for="texto_valor" class="col-sm-4 control-label">Texto Valor</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="texto_valor" v-model="data.texto_valor">
                <div class="help-block" v-for="(e,index) in errors['texto_valor']" :key="index">{{e}}</div>
            </div>
        </div>
        <div class="form-group" v-if="!data.activar_texto_modal" :class="{'has-error': errors['texto_institucion']}">
            <label for="texto_institucion" class="col-sm-4 control-label">Texto institución</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="texto_institucion" v-model="data.texto_institucion">
                <div class="help-block" v-for="(e,index) in errors['texto_institucion']" :key="index">{{e}}</div>
            </div>
        </div>
 
        <div class="form-group" :class="{'has-error': errors['onsite']}">
            <label for="onsite" class="col-sm-4 control-label">Disponible en ChileAtiende</label>
            <div class="col-sm-8">
                <el-switch
                    v-model="data.onsite"
                    on-text="SI"
                    off-text="NO"                    
                    >
                </el-switch>
                
            </div>
        </div>

        <div class="form-group" :class="{'has-error': errors['clave_unica']}">
            <label for="clave_unica" class="col-sm-4 control-label">Requiere Autenticación de Claveunica</label>
            <div class="col-sm-8">
                <el-switch
                    v-model="data.clave_unica"
                    on-text="SI"
                    off-text="NO"                    
                    >
                </el-switch>
                 
            </div>
        </div>

         <div class="form-group" :class="{'has-error': errors['permanente']}">
            <label for="permanente" class="col-sm-4 control-label">Activo permanentemente </label>
            <div class="col-sm-8  ">
                <el-switch
                    v-model="data.permanente"
                    on-text="SI"
                    off-text="NO"                    
                    >
                </el-switch>
                
            </div>
        </div>

        <div id="configura_evento" v-if="!data.permanente">
        <div class="form-group">
            <label class="col-sm-12 control-label subtitle"><em>Configuración de activo</em></label>
        </div>
        <div class="form-group" :class="{'has-error': errors['activo_desde']}">
            <label for="activo_desde" class="col-sm-4 control-label">Activo inicia</label>
            <div class="col-sm-8">
                <el-date-picker
                    v-model="data.activo_desde"
                    type="date"
                    format="dd-MM-yyyy"
                    placeholder="Seleccione una Fecha"
                    :disabled="data.permanente">
                </el-date-picker>
                <div class="help-block" v-for="(e,index) in errors['activo_desde']" :key="index">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['activo_hasta']}">
            <label for="activo_hasta" class="col-sm-4 control-label">Activo finaliza</label>
            <div class="col-sm-8">
                <el-date-picker
                    v-model="data.activo_hasta"
                    type="date"
                    format="dd-MM-yyyy"
                    popper-class="datepick1"
                    placeholder="Seleccione una Fecha"
                     :disabled="data.permanente">>
                </el-date-picker>
                <div class="help-block" v-for="(e,index) in errors['activo_hasta']" :key="index">{{e}}</div>
            </div>
        </div>
        </div>

 <div class="form-group">
            <label class="col-sm-12 control-label subtitle"><em>Configuración analytics</em></label>
        </div>
        
        <div class="form-group" :class="{'has-error': errors['ga_categoria']}">
            <label for="ga_categoria" class="col-sm-4 control-label">Categoría evento </label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="ga_categoria" v-model="data.ga_categoria">
                <div class="help-block" v-for="(e,index) in errors['ga_categoria']" :key="index">{{e}}</div>
            </div>
        </div>
          
        <div class="form-group" :class="{'has-error': errors['ga_accion']}">
            <label for="ga_accion" class="col-sm-4 control-label">Acción evento </label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="ga_accion" v-model="data.ga_accion">
                <div class="help-block" v-for="(e,index) in errors['ga_accion']" :key="index">{{e}}</div>
            </div>
        </div>

          
        <div class="form-group" :class="{'has-error': errors['ga_etiqueta']}">
            <label for="ga_etiqueta" class="col-sm-4 control-label">Etiqueta evento </label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="ga_etiqueta" v-model="data.ga_etiqueta">
                <div class="help-block" v-for="(e,index) in errors['ga_etiqueta']" :key="index">{{e}}</div>
            </div>
        </div>

        
        <div class="form-group">
            <div class="col-sm-offset-4 col-sm-8">
                <a class="btn btn-default" :href="'backend/fichas/'+ this.page.id + '/actions'">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    .el-select{
        display: block;
    }
    .el-picker-panel.el-date-picker.datepick1 {
        min-width: 295px !important;
    }
    .el-date-editor.el-input{
        min-width: 295px !important;
    }
    .subtitle {
        color: #757575;
        padding-top:20px !important;
        text-align: left !important;
    }
</style>
<script>
import ElementUI from 'element-ui';
import ElSelect from 'element-ui/lib/select';
import ElSwitch from 'element-ui/lib/switch';
import ElOption from 'element-ui/lib/option';
import ElDatePicker from 'element-ui/lib/date-picker';
import ElInput from 'element-ui/lib/input';
import locale from 'element-ui/lib/locale/lang/es';
import Vue from 'vue';
import { Message } from 'element-ui';
Vue.use(ElementUI, { locale });
export default {
    data: function(){
        const today = new Date();
        const base_date = new Date(today.getFullYear(),today.getMonth(),today.getDate()); //today at 00:00:00
        const data = {
            id: null,
            texto_boton: null,
            texto_valor: null,
            texto_institucion: null,
            url_destino: null,
            onsite: null,
            clave_unica: null,
            permanente: null,
            activar_texto_modal: null,
            texto_modal: null,
            activo_desde: base_date,
            activo_hasta: base_date, 
            ga_categoria: null,
            ga_accion:null,
            ga_etiqueta: null,
        };
        _.assign(data, this.action);
        if(this.edit){
            data.activo_desde = moment(data.activo_desde).toDate();
            data.activo_hasta = moment(data.activo_hasta).toDate();
        }else{
            data.permanente=true;
        }
        return{
            data: data,
            mostrar_rango: false,
            errors: {}
        }
    },
    components:{
        ElSelect,
        ElSwitch,
        ElOption,
        ElDatePicker,
        ElInput,
    },
    props: ['page', 'action', 'edit'],
    computed: {
        validateForm: function() { 
            this.errors = {};
            var error_texto_boton = this.data.texto_boton === '' || this.data.texto_boton === null;
            // var error_texto_valor = this.data.texto_valor === '' || this.data.texto_valor === null;
            // var error_texto_institucion = this.data.texto_institucion === '' || this.data.texto_institucion === null;
            var error_url_destino = this.data.url_destino === '' || this.data.url_destino === null;
            var error_inicio = this.data.activo_desde > this.data.activo_hasta;  
            var error_texto_modal = (this.data.activar_texto_modal && (!this.data.texto_modal || this.data.texto_modal === '')) || 
                                  (this.data.texto_modal && this.data.texto_modal.length > 160);
            var errores = {};
            if(error_texto_boton){ errores["texto_boton"] = ["El campo de texto del boton no puede estar vacío."]; }
            if(error_url_destino){ errores["url_destino"] = ["El campo url destino no puede estar vacio"]; } 
            if(error_inicio){ errores["activo_desde"] = ["La fecha de inicio no puede ser mayor a la fecha de finalización."]; }
            if(error_texto_modal){ 
                if(this.data.activar_texto_modal && (!this.data.texto_modal || this.data.texto_modal === '')) {
                    errores["texto_modal"] = ["El texto modal es requerido cuando Texto Libre está activado."];
                } else if(this.data.texto_modal && this.data.texto_modal.length > 160) {
                    errores["texto_modal"] = ["El texto modal no puede exceder los 160 caracteres."];
                }
            }
            
            
            if (error_texto_boton || error_url_destino || error_inicio || error_texto_modal){
                this.errors = errores;
                return true; 
            }else{
                return false;
            }
        }
    },
    methods:{
        
        submit: function(){
           
            var self = this;


            if (self.data.permanente == true){
                self.data.activo_desde =  self.data.activo_hasta = null;
            }

            if (self.validateForm){
                self.$message.error('Revise los errores en el formulario antes de continuar.');
            }else{
                if (self.edit){
                    var url_axios = 'backend/fichas/'+ self.page.id + '/actions/' + self.data.id;
                    var method_axios = 'PUT';
                } else {
                    var url_axios = 'backend/fichas/'+ self.page.id + '/actions/';
                    var method_axios = 'POST';
                }
                axios({
                    url: url_axios,
                    method: method_axios,
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    alert(error);
                    self.errors = error.response.data.errors;
                });
            }
        }
    },
    mounted: function(){
       
    }
}
</script>